import React from 'react';
import { INavigationItemProps, SmallBodyText, FlexRow, NavigationItem } from 'ui-toolkit';
import { NameControl } from './NameControl';
import { formatPhoneNumber } from 'utilities/shared/formatPhoneNumber';
import { DarkFaEdit } from '../DarkFaEdit';
import { IPartyPerson } from '../../../../../ui-toolkit/orders/interfaces/IPartyPerson';
import { IHasTestData } from '../../../../../ui-toolkit/test-utilities/IHasTestData';
import { mergeTests } from '../../../../../ui-toolkit/test-utilities/mergeTests';

export interface IPartyPersonRowProps extends IHasTestData {
  person: IPartyPerson;
  isUser: boolean;
  navEditStart?: INavigationItemProps;
}

export const PartyPersonRow: React.FC<IPartyPersonRowProps> = ({
  person,
  navEditStart,
  'data-test-id': dataTestID,
}) => {
  const secondContactLine = formatPhoneNumber(person.phone_number || '') || null;
  const firstContactLine = person.email || (secondContactLine && '');

  return (
    <>
      <FlexRow justifyContent={'space-between'}>
        <NameControl data-test-id={mergeTests(dataTestID, 'name')} party={person} showPartyType={true} />
        <NavigationItem text={`Edit`} {...navEditStart}>
          <DarkFaEdit />
        </NavigationItem>
      </FlexRow>
      <SmallBodyText>
        <SmallBodyText intent="faded" data-test-id={mergeTests(dataTestID, 'email')}>
          {firstContactLine}
        </SmallBodyText>
        <SmallBodyText intent="faded" data-test-id={mergeTests(dataTestID, 'phone')}>
          {secondContactLine}
        </SmallBodyText>
      </SmallBodyText>
    </>
  );
};
